/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum UserRoleEnum {
    Owner = 10,
    Employee = 20,
}
